import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
import { currentServerUnixTime, prettyTimeInterval, timeInPast_parts, } from 'utils';
import { DevicePermission, hasGuard } from 'console/device/device_ts';
import { LegacyDevice } from 'console/device/device';
import { usePartial } from 'shared/hooks/utils';
import { deviceRequestGuard } from 'console/redux/devices/items/actions';
import { TimedRenderer } from 'console/react-elements/timed-renderer';
import * as classnames from 'classnames';
import { Capability } from 'console/device/device-capability';
import { useAction } from 'shared/hooks/redux/hooks';
export const GuardCard = memo(function GuardCard(props) {
    const { active, r_device, account, server_time } = props;
    return (_jsx(GuardCardImpl, { active: active, account: account, r_device: r_device, server_time: server_time }));
});
export const GuardCardImpl = memo(function GuardCardImpl(props) {
    const { active, account, r_device, server_time } = props;
    const guard = r_device.guard_state;
    const lge = r_device.last_guard_event;
    const { date, time } = timeInPast_parts(new Date((lge?.time ?? 0) * 1e3), {
        accusative: true,
    });
    const onClickRequestGuard = useAction(usePartial(deviceRequestGuard, r_device.id, guard === 'disabled'));
    const memomizeGuardButton = useMemo(() => {
        if (r_device.guard_state__loading)
            return 'Отправка команды...';
        else if (['enabled', 'enabling'].includes(guard ?? ''))
            return 'Снять с охраны';
        else
            return 'Поставить на охрану';
    }, [r_device.guard_state__loading, guard]);
    const memomizeGuardTime = useCallback(() => {
        if (lge?.time) {
            const relative = currentServerUnixTime(server_time) - lge?.time;
            if (relative > 0) {
                const humantime = prettyTimeInterval(relative, {
                    accusative: true,
                });
                return _jsxs("span", { children: ["(", humantime, " \u043D\u0430\u0437\u0430\u0434)"] });
            }
            else {
                return _jsx("span", { children: "\u0442\u043E\u043B\u044C\u043A\u043E \u0447\u0442\u043E" });
            }
        }
        else {
            return null;
        }
    }, [lge?.time, server_time, currentServerUnixTime, prettyTimeInterval]);
    if (!hasGuard(r_device) ||
        LegacyDevice.has_capability(r_device?.capabilities, Capability.has_car_controls)) {
        return null;
    }
    if (LegacyDevice.has_capability(r_device?.capabilities, Capability.has_z3k_settings))
        return null;
    return (_jsxs("div", { className: "ui-falarm-main-view-guard ui-card", children: [guard != null && (_jsx("div", { className: classnames('ui-card-icon ui-icon-zta-guard', {
                    enabled: 'ui-icon-zta-guard-on',
                    enabling: 'ui-icon-zta-guard-enabling',
                    disabled: 'ui-icon-zta-guard-off',
                }[guard]) })), guard != null && (_jsx("h1", { children: {
                    enabled: 'Под охраной',
                    enabling: 'Постановка',
                    disabled: 'Снято с охраны',
                }[guard] })), lge != null && (_jsxs("div", { className: "last-guard-event", children: [_jsxs("span", { children: [{
                                GuardOff: 'Снято с охраны ',
                                GuardOn: 'Поставлено на охрану ',
                            }[lge.event], `${date} в ${time}`] }), _jsx("br", {}), _jsx(TimedRenderer, { active: active, interval: 10e3, children: memomizeGuardTime })] })), LegacyDevice.has_access(account.id, r_device, DevicePermission.control) && (_jsx("button", { onClick: onClickRequestGuard, disabled: !r_device.online || r_device.guard_state__loading, children: memomizeGuardButton }))] }));
});
